// extracted by mini-css-extract-plugin
module.exports = {"content":"RecoverForm_content__udBKy","form":"RecoverForm_form__3FKTG","input":"RecoverForm_input__3c5rM","action":"RecoverForm_action__20JGV"};